export default {
  properties: {
    year: {
      calc: {
        func: '$methods.moment().format("YYYY")',
        when: '!this.year'
      },
      fieldRequired: true,
      title: 'Wybierz rok',
      type: 'number'
    },

    documentDate: {
      fieldRequired: true,
      format: 'date',
      title: 'Data wystawienia dokumentu',
      type: 'string'
    },

    paymentYear: {
      fielRequired: true,
      title: 'Rok płatności',
      type: 'number',
      validFunc: [
        'const lastDecisionDate = $external.payments.filter(payment => payment.data.decisionDate).map(payment => payment.data.decisionDate).sort((a, b) => -a.localeCompare(b))[0];',
        'const lastDecisionYear = new Date(lastDecisionDate).getFullYear();',
        'if (lastDecisionYear > $value) {',
        '  return "Data wypłaty nie może być wcześniejsza niż data wydanego dokumentu.";',
        '}'
      ]
    },

    paymentMonth: {
      fielRequired: true,
      title: 'Miesiąc płatności',
      type: 'number',
      validFunc: [
        'const lastDecisionDate = $external.payments.filter(payment => payment.data.decisionDate).map(payment => payment.data.decisionDate).sort((a, b) => -a.localeCompare(b))[0];',
        'const lastDecisionYear = new Date(lastDecisionDate).getFullYear();',
        'const lastDecisionMonth = new Date(lastDecisionDate).getMonth();',
        'if (lastDecisionYear === this.paymentYear && lastDecisionMonth > $value) {',
        '  return "Data wypłaty nie może być wcześniejsza niż data wydanego dokumentu.";',
        '}'
      ]
    },

    firstName: {
      fieldRequired: true,
      title: 'Imię',
      type: 'string'
    },

    lastName: {
      fieldRequired: true,
      title: 'Nazwisko',
      type: 'string'
    },

    fullName: {
      calc: {
        func: '(this.firstName + " " + this.lastName).trim()',
        when: 'this.firstName && this.lastName'
      },
      fieldRequired: true,
      type: 'string'
    },

    phoneNumber: {
      fieldRequired: true,
      title: 'Numer telefonu',
      type: 'string'
    },

    email: {
      fieldRequired: true,
      format: 'email',
      title: 'Adres e-mail',
      type: 'string'
    }
  },
  title: 'Wniosek KO',
  type: 'object'
};
